var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linked-in_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.313.563H1.688A1.125 1.125 0 0 0 .563 1.688v14.625a1.125 1.125 0 0 0 1.125 1.125h14.625a1.125 1.125 0 0 0 1.125-1.125V1.688A1.125 1.125 0 0 0 16.313.563M5.56 14.959H3.023V6.891H5.56zm-1.27-9.176a1.477 1.477 0 1 1 .01-2.953 1.477 1.477 0 0 1-.01 2.953m10.683 9.176h-2.486v-3.902c0-.95 0-2.11-1.322-2.11S9.685 9.95 9.685 11.004v4.008H7.2V6.891h2.327v1.107h.052a2.64 2.64 0 0 1 2.38-1.318c2.539 0 3.015 1.687 3.015 3.85z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linked-in_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })))));
};
export default SvgLinkedIn;